module.exports = __webpack_public_path__ + "static/media/image_32.fb39cc4b.png";